import { Link } from '@mui/material';

import LaunchIcon from '@mui/icons-material/Launch';

const CustomLink = (props) => {
	return (
		<Link
			color='#22294d'
			underline='none'
			fontWeight='600'
			className='link'
			target='_blank'
			href={props.href}
		>
			{props.text}
			{/* <img style={{ maxWidth: '11px', marginLeft: '3px' }} src={img} alt="launch"/> */}
			<LaunchIcon sx={{ fontSize: '.9rem' }} />
		</Link>
	);
};

export default CustomLink;
